<div class="join-community-popup" [class.active]="active" (click)="onClick($event)">
  <div class="jcp-win">
    <div class="jcp-close" (click)="close();">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.1665 4.16699L15.8332 15.8337" stroke="#9C877A" stroke-width="0.8" stroke-linecap="round"/>
        <path d="M4.1665 15.833L15.8332 4.16634" stroke="#9C877A" stroke-width="0.8" stroke-linecap="round"/>
      </svg>

    </div>

    <div class="jcp-content" *ngIf="!isSuccess">
      <div class="jcp-head">
        <h2>ПРИЄДНУЙСЯ ДО<br>FOF СПІЛЬНОТИ</h2>
        <p>Щоб отримувати цікаві fashion-підбірки та<br>завчасно дізнаватися про унікальні пропозиції.</p>
      </div>

      <div class="jcp-form">
        <div class="jcp-input-group">
          <label>ВАШ EMAIL</label>
          <input
            type="email"
            [(ngModel)]="email"
            placeholder="MYEMAIL@GMAIL.COM"
            [class.error]="emailError"
            [disabled]="isLoading">
          <div class="error-message" *ngIf="emailError">{{emailError}}</div>
        </div>

        <div class="jcp-checkbox-group">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [(ngModel)]="agreeToPrivacy"
              [disabled]="isLoading">
            <span class="checkmark"></span>
            <span class="checkbox-text">
              Натискаючи тут, я погоджуюся з політикою конфіденційності
              та умовами використання
            </span>
          </label>
        </div>

        <div class="error-message" *ngIf="errorMessage">{{errorMessage}}</div>

        <div class="jcp-btnwrap">
          <button
            class="jcp-button"
            (click)="subscribe()"
            [disabled]="isLoading">
            <span *ngIf="!isLoading">ПІДПИСАТИСЬ</span>
            <span *ngIf="isLoading">ЗАВАНТАЖЕННЯ...</span>
          </button>
        </div>
      </div>
    </div>

    <div class="jcp-content jcp-success" *ngIf="isSuccess">
      <div class="jcp-head">
        <h2>ДЯКУЄМО!</h2>
        <p>Ви успішно приєдналися до FOF спільноти.</p>
      </div>
    </div>
  </div>
</div>
